import React from 'react';
import cn from 'classnames';
import { Route } from 'react-router-dom';

import DateSetting from './configComponents/Date';
import Color from './configComponents/Color';
import SortField from './configComponents/SortField';
import Split from './configComponents/Split';
import SortType from './configComponents/SortType';

import routes from '../../../../routes';
import styles from './config.less';

const Overlay = (props) => (
    <div className={cn('ant-dropdown-menu ant-dropdown-menu-vertical', styles.overlay)}>
      <DateSetting
        name="start"
        settings={props.viewSettings}
        fields={props.fields}
        catalogId={props.catalogId}
        viewId={props.viewId}
      />
      <DateSetting
        name="end"
        settings={props.viewSettings}
        fields={props.fields}
        catalogId={props.catalogId}
        viewId={props.viewId}
      />
      <Color settings={props.viewSettings} fields={props.fields} catalogId={props.catalogId} viewId={props.viewId} />
      <Route path={routes.calendarSettings.path}>
        {({ match }) => (
          <Split
            settings={props.viewSettings}
            fields={props.fields}
            catalogId={props.catalogId}
            viewId={props.viewId}
            view={match ? match.params.type : null}
          />
        )}
      </Route>
      <SortField settings={props.viewSettings} fields={props.fields} catalogId={props.catalogId} viewId={props.viewId} />
      <SortType settings={props.viewSettings} catalogId={props.catalogId} viewId={props.viewId} />
    </div>
  );

export default Overlay;
